import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Overlay} from '@angular/cdk/overlay';
import { ActivatedRoute } from '@angular/router';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';
import { Location } from '@angular/common';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-student-details',
  templateUrl: './student-details.component.html',
  styleUrls: ['./student-details.component.scss'],

})
export class StudentDetailsComponent implements OnInit, AfterViewInit {
  stepperForm: FormGroup;
  personalDetailsForm: FormGroup;
  contactDetailsForm: FormGroup;
  reservationsDetailsForm: FormGroup;
  qualificationDetailsForm: FormGroup;
  additionalDetailsForm: FormGroup;
  photoSignDetailsForm: FormGroup;
  admissionDetailsForm: FormGroup;
  documentDetailsForm: FormGroup;
  marritalList: any;
  filteredmarritalstatusList: any;
  filteredBloodGroupList: any;
  bloodgroupList: any;
  filteredGenderList: any;
  genderList: any;
  isDivShow: boolean;
  isreadonly = true;
  dialogRef1: MatDialogRef<any>;
  CountryCodeList: any;
  filteredListCountryCode: any;
  StateCodeList: any;
  filteredListState: any;
  districtCodeList: any;
  filteredListDistrict: any;
  qualList: any;
  regionList: any;
  filteredRegionList: any;
  filteredDomicileList: any;
  domicileList: any;
  filteredNationalityList: any;
  nationalityList: any;
  filteredMinorityList: any;
  minorityList: any;
  categoryList: any[];
  filteredCategoryList: any[];
  religionList: any;
  filteredReligionList: any;
  specialAbledList: any;
  filteredspecialAbledList: any;
  orphanTypeList: any;
  filteredorphanTypeList: any;
  ConstiCateList: any;
  filteredConstiCateList: any;
  userImage: any;
  signatureImage: any;
  proId: any;
  facultyList: any;
  filteredFacultyList: any;
  courseList: any;
  filteredCourseList: any;
  courseStreamList: any;
  filteredStreamList: any;
  examList: any;
  filteredExamList: any;
  stucourseClgMapList: any;
  filteredstucourseClgMapListList: any;
  ducumentList: any;
  ScrutinyLevel: 0;
  UserId: 0;
  ScrutinyId: 0;
  StudentId: any;
  CoCode: 0;
  CgCode: 0;
  SessionId: any;
  LoginName: any;
  FirstName: any;
  MiddleName: any;
  LastName: any;
  from: any;
  filteredstudyModeList: any;
  studyModeList: any;
  sTypeList: any;
  filteredsTypeList: any;
  mothertoungList: any;
  filteredMotherToungList: any;
  BranchId = 0;
  subList: any;
  filteredSubList: any;
  PassYearList: any;
  filteredPassYearList: any;
  courseLevelList: any;
  filteredcourseLevelList: any;
  courseQualList: any;
  filteredcourseList: any;
  boardUniList: any;
  filteredboardUniList: any;
  Subs = false;
  OptSub = false;
  Min: any;
  Max: any;
  SubjectName: any[] = [];
  ErrorMessage: string;
  optData: any;
  GroupData: any;
  SubError = false;
  selectedValues: any[] = [];
  Subjects: any[] = [];
  selectedCheckboxes: any = [];
  validationErrors: { [key: string]: string } = {};
  MinMax = false;
  years: number[] = this.generateYears(1975, new Date().getFullYear());
  newSelectedValues = [];
  Sub: any[] = [];
  AllSub: any[] = [];
  selectedOptions: any = [];

  SubjectData = [];
  StateCodeListP: any;
  filteredListStateP: any;
  districtCodeListP: any;
  filteredListDistrictP: any;
  SessionFilterList: any;
  sessionList: any;
  filteredtehasilPList: any;
  tehasilPList: any;
  tehasilCList: any[];
  filteredtehasilCList: any[];
  filteredListDistrictC: any;
  districtCodeListC: any;
  filteredListStateC: any;
  StateCodeListC: any;
  PCountryCodeList: any;
  filteredListPCountryCode: any;
  CfilteredListCountryCode: any;
  CCountryCodeList: any;
  SRList: any;
  filteredSR: any;
  dialogRef: MatDialogRef<any>;
  isformreadonly = true;
  filteredListAdmInfoCode: any;
  AdmInfoCodeList: any;
  EmpTypeCodeList: any;
  filteredListEmpTypeCode: any;
  MediumCodeList: any;
  filteredListMediumCode: any;
  collegedataList: any;
  filteredListCollege: any;
  districtList: any;
  filteredListdistrictCode: any;
  AdharPhone = false;
  AadharCard = false;
  AbcId = false
  message: string;
  constructor(private dialog: MatDialog, private location: Location,
    private fb: FormBuilder,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService,
    public datepipe: DatePipe, private overlay: Overlay,
    private route: ActivatedRoute) { }
  personalDetailsFormArray;
  contactDetailsFormArray;
  reservationsDetailsFormArray;
  qualificationDetailsFormArray;
  additionalDetailsFormArray;
  admissionDetailsFormArray;
  isOpen = true;
  data = [];
  showchat = false;
  showchattt = true
  readonly = true;
  isStuCasteDisable = false
  isStuCasteCertDisable = false
  isStuCasteValCertDisable = false;
  isStuNonCrmValDtDisable = false;
  isStuOrphanTypeDisable = false;
  isStuSpecialAbledTypeDisable = false;
  isStuMinorityTypeDisable = false;
  isStuNonCrmCertDisable = false
  isStuMinorityType2Disable = false;
  isStuInHouseDisable = false;
  isStuMinorityDisable = false;
  currentdate: any;
  isStuNonCrmValDtDisable2 = false;
  disableMinority = true;
  resultNotDec = false;
  UpdateBtn = false;
  PersonalShow = false;
  ContactShow = false;
  ReserveShow = false;
  AdditShow = false;
  QualifyShow = false;
  PhotoSignShow = false;
  AdmShow = false;
  DocDetailShow = false;
  ngOnInit(): void {
    this.currentdate = new Date();
    const state = history.state;
    this.PersonalShow = false;
    this.ContactShow = false;
    this.ReserveShow = false;
    this.AdditShow = false;
    this.QualifyShow = false;
    this.PhotoSignShow = false;
    this.AdmShow = false;
    this.DocDetailShow = false;
  this.ScrutinyLevel = this.getStateValue(state, 'ScrutinyLevel');
  this.UserId = this.getStateValue(state, 'UserId');
  this.ScrutinyId = this.getStateValue(state, 'ScrutinyId');
  this.StudentId = this.getStateValue(state, 'StudentId');
  this.LoginName = this.getStateValue(state, 'LoginFullName');
  this.FirstName = this.getStateValue(state, 'StuFirstName');
  this.MiddleName = this.getStateValue(state, 'StuMidName');
  this.LastName = this.getStateValue(state, 'StuLastName');
  this.CoCode = this.getStateValue(state, 'CoCode');
  this.CgCode = this.getStateValue(state, 'CgCode');
  this.SessionId = this.getStateValue(state, 'SessionId');
  this.from = state['from'];
  this.fetchFeeResponces(this.SessionId,this.StudentId);
    this.data.push({
      "ScrtLvl": this.ScrutinyLevel,
      "UserId": this.UserId,
      "ScrtId": this.ScrutinyId,
      "StdId": this.StudentId,
      "LoginName": this.LoginName,
      "FirstName": this.FirstName,
      "MidName": this.MiddleName,
      "LastName": this.LastName,
      "CoCode": this.CoCode,
      "CgCode": this.CgCode,
      "SessionId": this.SessionId,
      "from": this.from,
    })
    this.checkLock();
    if (this.from === 'report') {
      this.showchattt = false
      this.isformreadonly = true;
      this.UpdateBtn = true;
    } else {
      this.showchattt = true
      this.isformreadonly = false;
      this.UpdateBtn = false;
    }

    let id = '';
    this.stepperForm = new FormGroup({

      personalDetailsForm: new FormControl(),
      contactDetailsForm: new FormControl(),
      reservationsDetailsForm: new FormControl(),
      qualificationDetailsForm: new FormControl(),
      additionalDetailsForm: new FormControl(),
      photoSignDetailsForm: new FormControl(),
      admissionDetailsForm: new FormControl(),
      documentDetailsForm: new FormControl(),
    });

    this.personalDetailsForm = new FormGroup({
      StuRgNo: new FormControl(this.StudentId),
      StuId: new FormControl(""),
    });
    this.personalDetails();


    this.contactDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuAddrId: new FormControl(""),
    });
    this.contactDetails();

    this.reservationsDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuResId: new FormControl(''),
    });
    this.reservationDetails();

    this.qualificationDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuQualId: new FormControl(),
    });
    this.prepopulationQ();

    this.additionalDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuExtraId: new FormControl(),
    });
    this.prepopulationA();
    this.fetchEmpType();
    this.photoSignDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
      StuRgNo: new FormControl(this.StudentId),
      StuPhoto: new FormControl(''),
      StuSignature: new FormControl(''),

    });
    this.prepopulationPS();

    this.admissionDetailsForm = this.fb.group({
      StuId: new FormControl(this.StudentId),
    });
    this.admissionDetails();

    this.documentDetailsForm = this.fb.group({
      "StuRemarkConfirm": new FormControl(''),
      "StuRemarkCheck": new FormControl(''),
      arrData: this.fb.array([]),
    });
    this.fetchDocument();
    this.fetchCourseLevel();
    this.fetchPassYear();
    this.fetchCourseForQual();
    this.fetchBoardUni();
  }
  ngAfterViewInit(): void {

  }
  personalDetails() {
    this.prepopulationP();
    this.ageCalculate();
    this.fetchMarritalStatus();
    this.fetchBloodGroup();
    this.fetchGender();
    this.fetchMotherTounge();
    this.fetchAdmInfo();
  }

  contactDetails() {
    this.prepopulationC();
    this.fetchCountry();
    this.fetchDistrict();
    this.fetchState();
    this.fetchNationality();
    this.fetchDomicile();
    this.fetchRegion();
    this.fetchCountryP();
    this.fetchCountryC()
  }

  reservationDetails() {
    this.prepopulationR();
    this.fetchReligion();
    this.fetchSpAbled();
    this.fetchorphanType();
    this.fetchConstiCate();
    this.fetchSocialReservation();

  }

  admissionDetails() {
    this.prepopulationAD();
    this.getFacultyData();
    this.fetchStudyMode();
    this.fetchStudentType();
    this.getSessionData()
  }

  generateYears(startYear: number, endYear: number): number[] {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  }
  private getStateValue(state: any, key: string): any {
    return state[key] || localStorage.getItem(key);
  }
  prepopulationP() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.data.push({ "email": res.data[0].EmailID });
          this.data.push({ "birthDate": res.data[0].StuBirthDate });
          this.data.push({ "stuRgNo": res.data[0].StuRgNo });
          this.data.push({ "StuGender": res.data[0].StuGender });
          this.data.push({ "StuNumber": res.data[0].StuNumber });
          this.data.push({ "EmailID": res.data[0].EmailID });
          this.data.push({ "StuMothNameEng": res.data[0].StuMothNameEng });
          this.prepopulatedatapageP(res);
        } else {
          this.loadsettingspageP();
        }
      } else {
        this.spinner.hide();
        this.loadsettingspageP();
      }
    })

  }
  prepopulatedatapageP(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';

    this.personalDetailsForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.personalDetailsForm.controls['StuRgNo'].setValue(e.data[0]['StuRgNo']);

    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));

            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));

            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.personalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }
  loadsettingspageP() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'PersonalDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.personalDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.personalDetailsForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });

      this.mapdataaa(res.data);
    });
  }
  updatePersonalDetails() {
    this.spinner.show();
    let submitpayload = this.personalDetailsForm.value;
    let da = this.personalDetailsForm.value.StuBirthDate;
    submitpayload['StuBirthDate'] = this.datepipe.transform(da, 'yyyy-MM-dd');
    submitpayload['StuPassYr'] = parseInt(this.personalDetailsForm.value.StuPassYr);
    submitpayload['LoginId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.updatePersonalDetails(submitpayload).subscribe(
      (res) => {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });

  }

  checkLock() {
    this.spinner.show();
    this.route.queryParams.subscribe(
      params => {
        this.UpdateBtn = false;
        const payload = {};
        payload['UserId'] = parseInt(sessionStorage.getItem('userId'));
        payload['StudentId'] = parseInt(this.StudentId);
        payload['SessionId'] = parseInt(this.SessionId);
        this.umsService.ScrutinyLock(payload).subscribe((res) => {
          if (res.status) {
            this.spinner.hide();
            let Data = res.data[0]
            if(this.from != 'report'){
              if (Data.Status == 'APPR' && Data.FinalApproval == true && params['UserId'] == Data.HistoryUserId) {
                this.UpdateBtn = true;
                this.isformreadonly = true;
              }
            }
            else {
              this.UpdateBtn = false; 
            }
            
          } else {
            this.spinner.hide();
            this.UpdateBtn = false;
          }
        },
        );
      })



  }
  mapdataaa(e) {
    this.personalDetailsFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
    this.PersonalShow = true;
  }
  ageCalculate() {
    let payload = this.personalDetailsForm.value;
    if (payload.StuBirthDate) {
      var timeDiff = Math.abs(
        Date.now() - new Date(payload.StuBirthDate).getTime()
      );
      let age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
      this.personalDetailsForm.controls['StuAge'].setValue(age);
    }
  }
  fetchCountryP() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListP = []
    this.filteredListStateP = []
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
        this.PCountryCodeList = res.data;
        this.filteredListPCountryCode = this.PCountryCodeList.slice();
    })
  }

  fetchCountryC() {
    this.spinner.show();
    const payload = {};
    this.StateCodeListC = []
    this.filteredListStateC = []
    this.districtCodeListC = []
    this.filteredListDistrictC = []
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.filteredListStateC = []
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
        this.CCountryCodeList = res.data;
        this.CfilteredListCountryCode = this.CCountryCodeList.slice();
    })
  }
  fetchStateP(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
        this.contactDetailsForm.controls["StuStateP"].setValue('');
      } else {
        this.spinner.hide();
      }
    })
  }
  fetchStateP2(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
    })
  }
  fetchStateP3(CountryCode) {
    this.spinner.show();
    const payload = {};
    this.districtCodeListP = []
    this.filteredListDistrictP = []
    this.tehasilPList = []
    this.filteredtehasilPList = []
    this.filteredListStateP = []
    this.StateCodeListP = []
    payload['CountryCode'] = CountryCode;
    this.umsService.getCountryWiseState(payload).subscribe(res => {
      this.spinner.hide();
        this.StateCodeListP = res.data;
        this.filteredListStateP = this.StateCodeListP.slice();
    })
  }
  fetchStateC(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
        this.contactDetailsForm.controls["StuStateC"].setValue('');
    })
  }
  fetchStateC2(CountryCode) {
    this.spinner.show();
    const payload = {};
    payload['CountryCode'] = CountryCode;
    this.filteredListStateC = [];
    this.StateCodeListC = []
    this.districtCodeListC = [];
    this.filteredListDistrictC = [];
    this.tehasilCList = [];
    this.filteredtehasilCList = [];
    this.umsService.getCountryWiseState(payload).subscribe(res => {
        this.spinner.hide();
        this.StateCodeListC = res.data;
        this.filteredListStateC = this.StateCodeListC.slice();
    })
  }
  fetchDistrictP(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
        this.contactDetailsForm.controls["StuDistrictP"].setValue('');
    })
  }
  fetchDistrictP2(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
    })
  }

  fetchDistrictP3(StateCode) {
    this.spinner.show();
    const payload = {};
    this.tehasilPList = []
    this.filteredtehasilPList = []
    payload['DsStateCode'] = StateCode;
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeListP = res.data;
        this.filteredListDistrictP = this.districtCodeListP.slice();
    })
  }
  fetchDistrictC(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
        this.contactDetailsForm.controls["StuDistrictC"].setValue('');
    })
  }
  fetchDistrictC2(StateCode) {
    this.spinner.show();
    const payload = {};
    payload['DsStateCode'] = StateCode;
    this.tehasilCList = []
    this.filteredtehasilCList = []
    this.umsService.getStateWiseDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeListC = res.data;
        this.filteredListDistrictC = this.districtCodeListC.slice();
    })
  }
  getTehasilDataC(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
      this.contactDetailsForm.controls["StuTehsilC"].setValue('');
    });
  }
  getTehasilDataC2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilCList = res.data;
      this.filteredtehasilCList = this.tehasilCList.slice();
    });
  }
  getTehasilDataP(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
      this.contactDetailsForm.controls["StuTehsilP"].setValue('');
    });
  }
  getTehasilDataP2(DsCode) {
    this.spinner.show();
    const payload = {};
    payload['Dscode'] = DsCode;
    this.umsService.getDistrictWiseTehasil(payload).subscribe(res => {
      this.spinner.hide();
      this.tehasilPList = res.data;
      this.filteredtehasilPList = this.tehasilPList.slice();
    });
  }
  fetchMarritalStatus() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'MarSt';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.marritalList = res.data;
        this.filteredmarritalstatusList = this.marritalList.slice();
    });
  }
  fetchBloodGroup() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Bld';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.bloodgroupList = res.data;
        this.filteredBloodGroupList = this.bloodgroupList.slice();
    });
  }
  copyAddress(e) {
    if (e.checked == true) {
      this.isreadonly = true;
      let payload = this.contactDetailsForm.value.StuAddrC;
      let payload2 = this.contactDetailsForm.value.StuCountryC;
      this.fetchStateP3(payload2);
      let payload3 = this.contactDetailsForm.value.StuStateC;
      this.fetchDistrictP3(payload3)
      let payload4 = this.contactDetailsForm.value.StuDistrictC;
      let payload6 = this.contactDetailsForm.value.StuCityC;
      let payload7 = this.contactDetailsForm.value.StuPinC;
      this.contactDetailsForm.controls["StuAddrP"].setValue(payload);
      this.contactDetailsForm.controls["StuCountryP"].setValue(payload2);
      this.contactDetailsForm.controls["StuStateP"].setValue(payload3);
      this.contactDetailsForm.controls["StuDistrictP"].setValue(payload4);
      this.contactDetailsForm.controls["StuCityP"].setValue(payload6);
      this.contactDetailsForm.controls["StuPinP"].setValue(payload7);

    }
    else {
      this.isreadonly = false;
      this.contactDetailsForm.controls["StuAddrP"].setValue('');
      this.contactDetailsForm.controls["StuCountryP"].setValue('');
      this.contactDetailsForm.controls["StuStateP"].setValue('');
      this.contactDetailsForm.controls["StuDistrictP"].setValue('');
      this.contactDetailsForm.controls["StuCityP"].setValue('');
      this.contactDetailsForm.controls["StuPinP"].setValue('');
    }
  }


  updateContaceDetails() {
    this.spinner.show();
    let payload = this.contactDetailsForm.value;
    payload['LoginId'] = parseInt(sessionStorage.getItem('StudentRGID'))
    if (this.contactDetailsForm.value.StuSameAddr == 1 || this.contactDetailsForm.value.StuSameAddr == true) {
      payload['StuAddrP'] = this.contactDetailsForm.value.StuAddrC;
      payload['StuCountryP'] = this.contactDetailsForm.value.StuCountryC;
      payload['StuStateP'] = this.contactDetailsForm.value.StuStateC;
      payload['StuDistrictP'] = this.contactDetailsForm.value.StuDistrictC;
      payload['StuCityP'] = this.contactDetailsForm.value.StuCityC;
      payload['StuPinP'] = this.contactDetailsForm.value.StuPinC;
    }
    payload['LoginId'] = parseInt(sessionStorage.getItem('userId'));;
    this.umsService.updateContactDetails(payload).subscribe(res => {
      this.spinner.hide();
      let data = {}
      data['message'] = res.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    },
    );
  }


  getSessionData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = res.data;
      this.SessionFilterList = this.sTypeList.slice();
    },);
  }

  fetchGender() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.genderList = res.data;
        this.filteredGenderList = this.genderList.slice();
    });
  }
  fetchMotherTounge() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Lang';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.mothertoungList = res.data;
        this.filteredMotherToungList = this.mothertoungList.slice();
    });
  }

  prepopulationC() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchContactDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          this.fetchStateC2(res.data[0].StuCountryC);
          this.fetchStateP2(res.data[0].StuCountryP);
          this.fetchDistrictC2(res.data[0].StuStateC);
          this.fetchDistrictP2(res.data[0].StuStateP);
          if (res.data[0].StuSameAddr == 1) {
            this.isreadonly = true;
          } else {
            this.isreadonly = false;
          }
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.data.push({ "StuAddrC": res.data[0].StuAddrC });
          this.data.push({ "StuAddrP": res.data[0].StuAddrP });
          this.data.push({ "StuPinC": res.data[0].StuPinC });
          this.data.push({ "StuPinP": res.data[0].StuPinP });
          this.prepopulatedatapageC(res);
        } else {
          this.loadsettingspageC();
        }
      } else {
        this.loadsettingspageC();
      }
    })
  }

  prepopulatedatapageC(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.contactDetailsForm.controls['StuAddrId'].setValue(e.data[0]['StuAddrId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.contactDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.contactDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ContactShow = true;
    });
  }
  loadsettingspageC() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ContactDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            } else {
              this.contactDetailsForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.contactDetailsForm.addControl(
              element.FormControlName,
              new FormControl('')
            );
          }
        }
      });
      this.contactDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ContactShow = true;
    });
  }
  fetchCountry() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCountry(payload).subscribe(res => {
      this.spinner.hide();
        this.CountryCodeList = res.data;
        this.filteredListCountryCode = this.CountryCodeList.slice();
    })
  }
  fetchState() {
    this.spinner.show();
    const payload = {};
    this.umsService.getState(payload).subscribe(res => {
      this.spinner.hide();
        this.StateCodeList = res.data;
        this.filteredListState = this.StateCodeList.slice();
    })
  }
  fetchDistrict() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      this.spinner.hide();
        this.districtCodeList = res.data;
        this.filteredListDistrict = this.districtCodeList.slice();
    })
  }

  fetchNationality() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'NL';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.nationalityList = res.data;
        this.filteredNationalityList = this.nationalityList.slice();
    });
  }
  fetchDomicile() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Dm';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.domicileList = res.data;
        this.filteredDomicileList = this.domicileList.slice();
    });
  }
  fetchRegion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Regio';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.regionList = res.data;
        this.filteredRegionList = this.regionList.slice();
    });
  }
  fetchCourseLevel() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'COLVL';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.courseLevelList = res.data;
        this.filteredcourseLevelList = this.courseLevelList.slice();
    });
  }
  fetchPassYear() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'PaYr';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.PassYearList = res.data;
        this.filteredPassYearList = this.PassYearList.slice();
    });
  }
  fetchCourseForQual() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Cours';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.courseQualList = res.data;
        this.filteredcourseList = this.courseQualList.slice();
    });
  }
  fetchBoardUni() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'BOARD';

    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.boardUniList = res.data;
        this.filteredboardUniList = this.boardUniList.slice();
    });
  }
  prepopulationR() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchReservationDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {

          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.fetchMinorityType(res.data[0].StuMinorityType);
          this.StuMinorityTypeDisable2(res.data[0])
          this.fetchCast(res.data[0].StuConstiSubCate);
          this.data.push({ "StuConstiSubCate": res.data[0].StuConstiSubCate });
          this.prepopulatedatapageR(res);
        } else {
          this.loadsettingspageR();
        }
      } else {
        this.loadsettingspageR();
      }
    })
  }
  StuMinorityTypeDisable2(e) {
    if (e.StuMinority === 2 || e.StuMinority == 2) {
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    } else {
      this.isStuMinorityTypeDisable = false
      this.isStuMinorityType2Disable = false
    }
  }
  onSelectionCastCertificat2(e) {
    if (e == '2') {
      this.isStuCasteValCertDisable = true;
      this.isStuNonCrmValDtDisable = true;
      this.isStuNonCrmValDtDisable2 = true
    }
  }

  StuOrphanTypeDisable2(e) {
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
    }
    else if (e == 2) {
      this.isStuOrphanTypeDisable = true
    }
  }

  StuSpecialAbledTypeDisable2(e) {
    if (e == 1) {
      this.isStuSpecialAbledTypeDisable = false
    }
    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
    }
  }
  fetchMinorityType2(value) {
    this.spinner.show();
    this.disableMinority = false;
    const payload = {};
    if (value === 1) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else if (value === 2) {
      this.isStuMinorityType2Disable = false;
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
    else {
      this.spinner.hide()
      this.isStuMinorityType2Disable = true;
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');
      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      payload['MinorityType'] = 3;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }
  prepopulatedatapageR(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.reservationsDetailsForm.controls['StuResId'].setValue(e.data[0]['StuResId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
            this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        } else {
          this.reservationsDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.reservationsDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReserveShow = true;
    });
  }
  loadsettingspageR() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'ReserveDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
            this.reservationsDetailsForm.addControl(
              element.FormControlName,
              new FormControl('')
            );
        }
      });
      this.reservationsDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.ReserveShow = true;
    });
  }
  fetchMinorityType(value) {
    this.spinner.show();
    const payload = {};
    if (value === 1) {
      payload['MinorityType'] = 1;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        }
        else {
        }
      });
    } else {
      payload['MinorityType'] = 2;
      this.umsService.fetchMinority(payload).subscribe((res) => {
        this.spinner.hide();
        if (res.status) {
          this.minorityList = res.data;
          this.filteredMinorityList = this.minorityList.slice();
        } else {

        }
      });
    }
  }
  fetchCast(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;
      this.spinner.show()
      const payload = {};
      this.categoryList = [];
      this.filteredCategoryList = [];
      payload['CategoryId'] = value;
      this.umsService.fetchCategory(payload).subscribe((res) => {
        this.spinner.hide()
        if (res.status) {
          this.categoryList = res.data;
          this.filteredCategoryList = this.categoryList.slice();
        }
        else {

        }

      });
    }


  }

  fetchCast2(value) {
    if (value == 'GM') {
      this.isStuCasteDisable = true
      this.isStuCasteCertDisable = true
      this.isStuCasteValCertDisable = true
      this.isStuNonCrmCertDisable = true
      this.isStuNonCrmValDtDisable = true
      this.isStuInHouseDisable = true
      this.isStuMinorityDisable = true
      this.isStuMinorityTypeDisable = true
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.get('StuCaste').patchValue('');
      this.reservationsDetailsForm.get('StuCasteCert').patchValue(2);
      this.reservationsDetailsForm.get('StuCasteValCert').patchValue(3);
      this.reservationsDetailsForm.get('StuNonCrmCert').patchValue(2);
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.reservationsDetailsForm.get('StuInHouse').patchValue(2);
      this.reservationsDetailsForm.get('StuMinority').patchValue(2);
      this.reservationsDetailsForm.get('StuMinorityType').patchValue(3);
      this.reservationsDetailsForm.get('StuMinorityType2').patchValue('');

      this.reservationsDetailsForm.get('StuMinorityType2').markAsUntouched();
      this.reservationsDetailsForm.get('StuNonCrmValDt').markAsUntouched();
      this.reservationsDetailsForm.get('StuCaste').markAsUntouched();
    }
    else {
      this.isStuCasteDisable = false;
      this.isStuCasteCertDisable = false;
      this.isStuCasteValCertDisable = false;
      this.isStuNonCrmCertDisable = false;
      this.isStuNonCrmValDtDisable = false;
      this.isStuInHouseDisable = false;
      this.isStuMinorityDisable = false;
      this.isStuMinorityTypeDisable = false;
      this.isStuMinorityType2Disable = false;

    }

    this.spinner.show()
    const payload = {};
    this.categoryList = [];
    this.filteredCategoryList = [];
    payload['CategoryId'] = value;
    this.umsService.fetchCategory(payload).subscribe((res) => {
      this.spinner.hide()
        this.categoryList = res.data;
        this.filteredCategoryList = this.categoryList.slice();
    });
  }
  fetchReligion() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Reg';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.religionList = res.data;
        this.filteredReligionList = this.religionList.slice();
    });
  }
  fetchSpAbled() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SpAb';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.specialAbledList = res.data;
        this.filteredspecialAbledList = this.specialAbledList.slice();
    });
  }
  fetchorphanType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'Op';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.orphanTypeList = res.data;
        this.filteredorphanTypeList = this.orphanTypeList.slice();
    });
  }
  fetchConstiCate() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'CS';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.ConstiCateList = res.data;
        this.filteredConstiCateList = this.ConstiCateList.slice();
    });
  }

  fetchSocialReservation() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SR';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.SRList = res.data;
        this.filteredSR = this.SRList.slice();
    });
  }
  prepopulationQ() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageQ(res);
        } else {
          this.loadsettingspageQ();
        }
      } else {
        this.loadsettingspageQ();
      }
    })
  }
  prepopulatedatapageQ(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e.data[0]['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
              this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName],));
        } else {
          this.qualificationDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });

    this.fetchQualDetailsForTable();
  }
  loadsettingspageQ() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
              this.qualificationDetailsForm.addControl(
                element.FormControlName,
                new FormControl('')
              );
        }
      });
      this.qualificationDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.QualifyShow = true;
    });

    this.fetchQualDetailsForTable();
  }
  fetchQualDetailsForTable() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    payload['StuQualId'] = '';
    this.umsService.fetchQualificationDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.qualList = res.data;
      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;
      }
    })
  }
  onSelectionChanged2({ value }) {
    if (value = 2) {
      this.resultNotDec = true;
      this.qualificationDetailsForm.get('StuPassYr').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarkListRgNo').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksObt').markAsUntouched();
      this.qualificationDetailsForm.get('StuMarksTot').markAsUntouched();
      this.qualificationDetailsForm.get('StuPercent').markAsUntouched();
      this.qualificationDetailsForm.get('StuCgpi').markAsUntouched();
      this.qualificationDetailsForm.get('StuClass').markAsUntouched();
      this.qualificationDetailsForm.get('fileUploadData').markAsUntouched();
      this.qualificationDetailsForm.controls['StuPassYr'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPassYr'].clearValidators();
      this.qualificationDetailsForm.controls['StuPassYr'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarkListRgNo'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuMarksObt'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksObt'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksObt'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuMarksTot'].setErrors(null);
      this.qualificationDetailsForm.controls['StuMarksTot'].clearValidators();
      this.qualificationDetailsForm.controls['StuMarksTot'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuPercent'].setErrors(null);
      this.qualificationDetailsForm.controls['StuPercent'].clearValidators();
      this.qualificationDetailsForm.controls['StuPercent'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuCgpi'].setErrors(null);
      this.qualificationDetailsForm.controls['StuCgpi'].clearValidators();
      this.qualificationDetailsForm.controls['StuCgpi'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['StuClass'].setErrors(null);
      this.qualificationDetailsForm.controls['StuClass'].clearValidators();
      this.qualificationDetailsForm.controls['StuClass'].updateValueAndValidity();
      this.qualificationDetailsForm.controls['fileUploadData'].setErrors(null);
      this.qualificationDetailsForm.controls['fileUploadData'].clearValidators();
      this.qualificationDetailsForm.controls['fileUploadData'].updateValueAndValidity();
    } else {
      this.resultNotDec = false;
    }
  }

  onselectPrepopulate(e) {
    this.spinner.show();
    this.onSelectionChanged2(e);
    this.qualificationDetailsFormArray = [];
    let payload = {};
    payload['FormPage'] = 'QualifyDetails';
    this.qualificationDetailsForm.controls['StuQualId'].setValue(e['StuQualId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible == true) {
              this.qualificationDetailsForm.controls[element.FormControlName].setValue(e[element.FormControlName]);
        }
      }

      );
      this.qualificationDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));

    });
  }
  prepopulationA() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAdditionalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          if(res.data[0].StuABCId == 2){
            this.AdharPhone = true;
            this.AbcId = false
          }
          else if(res.data[0].StuABCId == 1){
            this.AdharPhone = false;
            this.AbcId = true
          }

          if(res.data[0].StuAadhar == 1){
            this.AadharCard = true
          }
          else if(res.data[0].StuAadhar == 2){
            this.AadharCard = false
          }
          this.fetchDate(res.data)
          this.getCollegeData(res.data[0].StuDistrictAd)
          this.getDistrictData();
          this.fetchMedium();
          sessionStorage.setItem("StudentDocumentID", res.data[0].StuId);
          this.prepopulatedatapageA(res);
        } else {
          this.loadsettingspageA();
        }
      } else {
        this.loadsettingspageA();
      }
    })
  }


  prepopulatedatapageA(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.additionalDetailsForm.controls['StuExtraId'].setValue(e.data[0]['StuExtraId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        } else {
          this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.additionalDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdditShow = true;
    });
  }
  loadsettingspageA() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdditionalDetail';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
              this.additionalDetailsForm.addControl(element.FormControlName, new FormControl(''));
        }
      });
      this.additionalDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdditShow = true;
    });
  }


  prepopulationPS() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      this.spinner.hide();

      const data = res.data[0];
      this.proId = res.data[0].StuProfId;
      if (res.status) {
        if (res.data.length > 0) {
          this.umsService.disable6 = false;
          this.photoSignDetailsForm = this.fb.group({
            StuId: new FormControl(data.StuId),
            StuRgNo: new FormControl(data.StuRgNo),
            StuPhoto: new FormControl(data.StuPhoto),
            StuSignature: new FormControl(data.StuSignature),
          });
          this.userImage = res.data[0].StuPhoto
          this.signatureImage = res.data[0].StuSignature
          this.PhotoSignShow = true;
        }
        else {
        }
      } else {

      }
    })
  }

  fetchDate(item) {
    if (item[0].StuFromDate == "1970-01-01" && item[0].StuToDate == "1970-01-01") {
      item[0].StuFromDate = '';
      item[0].StuToDate = ''
    }
  }
  prepopulationAD() {
    this.spinner.show()
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        res.data[0].StuBrId = parseInt(res.data[0].StuBrId);
        res.data[0].StuEmId = parseInt(res.data[0].StuEmId);
        this.getExamForLateral(res.data[0].StuEmId);
        res.data[0].StuSubjectRg = res.data[0].StuSubjectRg.split(",")
        if (res.data.length > 0) {
          sessionStorage.setItem("StudentPersonalId", res.data[0].StuId);
          sessionStorage.setItem("StuAcadId", res.data[0].StuAcadId);

          this.getCourseData(res.data[0].StuFacId);
          this.getExamStreamData(res.data[0].StuCoId,res.data[0].StuBrId);
          this.selectedValues = res.data[0].StuSubjectRg;
          const dataArray = res.data[0].StuSubjectRgCopy.split(',');
          dataArray.forEach(item => {
            const splitValues = item.split('-');
            const obj = {
              Code: splitValues[0],
              Id: splitValues[1]
            };
            this.newSelectedValues.push(obj);
          });
          this.data.push({ "subjects": res.data[0].StuSubjectRg });
          this.prepopulatedatapageAD(res);

        } else {
          this.showchat = true;
          this.loadsettingspageAD();
        }
      }
      else {
        this.loadsettingspageAD();
      }
    })
  }

  getExamForLateral(id){
    const payload2 = {};
    payload2['EmId'] = id;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.data.push({ "EmSrNo": res.data[0].EmSrNo });
    });
  }
  shouldCheckItemForGroup(child): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === child.EsId);
  }

  shouldCheckItemForSubject(item1): boolean {
    return this.selectedCheckboxes.some(item => item.EsId === item1.EsId);
  }
  getBrId(id) {
    this.BranchId = id;
  }

  getSubData(id) {
    this.spinner.show()
    const payload = {};
    payload['EsEmId'] = id.EmId;
    payload['EsStrId'] = this.BranchId;
    this.umsService.fetchSubs(payload).subscribe(res => {
      this.spinner.hide()
      this.ErrorMessage = '';
      this.SubError = false;
      this.Subjects = [];
      this.selectedCheckboxes = [];
      this.SubjectName = [];
      this.MinMax = false;
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.getExamSubMapFetch(this.admissionDetailsForm.value['StuEmId'], this.BranchId);
      this.subList = res.data;
      this.filteredSubList = this.subList.slice();
    });
  }
  prepopulatedatapageAD(e) {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      this.spinner.hide();
      ress.data.forEach((element) => {
        if (element.FormVisible) {
              this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));

        }
        else {
          this.admissionDetailsForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.admissionDetailsFormArray = ress.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdmShow = true;
    });

  }
  loadsettingspageAD() {
    this.spinner.show();
    let payload = {};
    payload['FormPage'] = 'AdmDetails';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      this.spinner.hide();
      res.data.forEach((element) => {
        if (element.FormVisible) {
              this.admissionDetailsForm.addControl(
                element.FormControlName,
                new FormControl('')
              );
        }
      });
      this.admissionDetailsFormArray = res.data.reduce(function (r, a) {
        r[a.FormControlName] = r[a.FormControlName] || [];
        r[a.FormControlName].push(a);
        return r;
      }, Object.create(null));
      this.AdmShow = true;
    });
  }
  getFacultyData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      this.spinner.hide();
      this.facultyList = res.data;
      this.filteredFacultyList = this.facultyList.slice();
    });
  }
  fetchStudyMode() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'AMODE';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.studyModeList = res.data;
        this.filteredstudyModeList = this.studyModeList.slice();
    });
  }
  fetchStudentType() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'STYPE';
    this.umsService.getCodeType(payload).subscribe((res) => {
      this.spinner.hide();
        this.sTypeList = res.data;
        this.filteredsTypeList = this.sTypeList.slice();
    });
  }

  onCheckbox(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
  }

  onCheckboxChanged(event: any, checkbox: any): void {
    const index = this.selectedCheckboxes.indexOf(checkbox);
    const isChecked = event.checked;
    if (isChecked && index === -1) {
      this.selectedCheckboxes.push(checkbox);
    } else if (!isChecked && index !== -1) {
      this.selectedCheckboxes.splice(index, 1);
    }
    this.validateCheckboxesForItem();
  }

  validateCheckboxesForItem(): void {
    for (const item of this.optData) {
      const selectedForItem = this.selectedCheckboxes.filter(
        (checkbox) => checkbox.EsOpCode === item.OpCode
      );

      this.validateCheckboxes(item, selectedForItem);
    }
  }

  validateCheckboxes(item: any, selectedCheckboxes: any[]): void {
    const totalSelected = selectedCheckboxes.length;
    const opMin = item.OpMin;
    const opMax = item.OpMax;
    if (totalSelected < opMin || totalSelected > opMax) {
      this.validationErrors[item.OpCode] = `Selected checkboxes should be between ${opMin} and ${opMax}`;
    } else {
      delete this.validationErrors[item.OpCode];
    }
  }


  getCourseData(id) {
    this.spinner.show();
    const payload = {};
    payload['CoFcCode'] = id;
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
    });
  }
  getExamStreamData(id,StrId) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = id;
    payload['EmId'] = 0;
    this.umsService.getExamStream(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status && res.data.length > 0) {
        res.data.forEach(element => {
          if(element.StrId == StrId){
            this.data.push({ "StrCode": element.StrCode });
          }
        });
        
        this.courseStreamList = res.data;
        this.filteredStreamList = this.courseStreamList.slice();
        this.showchat = true;
      } else {
        this.showchat = true;
      }

    },
    );

    const payload2 = {};
    payload2['EmCoCode'] = id;
    payload2['EmId'] = 0;
    this.umsService.getExam(payload2).subscribe(res => {
      this.spinner.hide();
      this.examList = res.data;
      this.filteredExamList = this.examList.slice();
    });

    const payload3 = {};
    payload3['CoCode'] = id;
    this.umsService.courseClg(payload3).subscribe(res => {
      this.spinner.hide();
      this.stucourseClgMapList = res.data;
      this.filteredstucourseClgMapListList = this.stucourseClgMapList.slice();
    });

  }

  fetchDocument() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = this.StudentId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.DocDetailShow = true;
      this.ducumentList = res.data;
      if (res.data.length == 0) {
        this.isDivShow = false;
      }
      else {
        this.isDivShow = true;
      }
    });
  }

  fetchForupdate(data) {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = data.StuId;
    payload['StuDocId'] = data.StuDocId;
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      let data = res.data[0];


      sessionStorage.setItem('StuDocId', data.StuDocId)
      if (res.status) {
        let StuRemarkCheck = false;
        if (data.StuRemarkCheck == 1) {
          StuRemarkCheck = true;
        } else {
          StuRemarkCheck = false;
        }
        this.documentDetailsForm = this.fb.group({
          arrData: this.fb.array([]),
          StuId: new FormControl(data.StuId),
          StuSrNo: new FormControl(data.StuSrNo, [Validators.required]),
          StuDocumentName: new FormControl(data.StuDocumentName, Validators.required),
          StuRemark: new FormControl(data.StuRemark, Validators.required),
          StuFileUpload: new FormControl(data.StuFileUpload),
          StuRemarkConfirm: new FormControl(data.StuRemarkConfirm),
          StuRemarkCheck: new FormControl(StuRemarkCheck),
        });
        let preArr = [];
        const tmpDict = {};
        tmpDict['StuId'] = new FormControl(data.StuId);
        tmpDict['StuSrNo'] = new FormControl(data.StuSrNo, [Validators.required]);
        tmpDict['StuDocumentName'] = new FormControl(data.StuDocumentName),
          tmpDict['StuRemark'] = new FormControl(data.StuRemark);
        tmpDict['StuFileUpload'] = new FormControl(data.StuFileUpload);
        tmpDict['StuRemarkConfirm'] = new FormControl(data.StuRemarkConfirm);
        tmpDict['StuRemarkCheck'] = new FormControl(data.StuRemarkCheck);
        const creds = this.documentDetailsForm.controls.arrData as FormArray;
        creds.push(new FormGroup(tmpDict));
      } else {
      }

    });

  }



  showbase64(e) {
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.fileUploadData
      });
  }


  showbase642(e) {
    const dialogRef3 = this.dialog.open(PdfViewerComponent,
      {
        width: "400px",
        height: "500px",
        data: e.StuFileUpload
      });
  }

  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }



  getExamSubMapFetch(EmId, BranchId) {
    this.Subjects = [];
    this.GroupData = [];
    this.Subs = false;
    this.OptSub = false;
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = EmId;
    payload['EsStrId'] = BranchId;
    this.umsService.getExamSubMapFetch(payload).subscribe(async res => {
      this.spinner.hide();
      this.SubjectData = res.data.children;
      this.SubjectData.forEach(element => {
        if (element.EsType == 'S') {
          this.Subs = true;
          if (this.Subjects.indexOf(element.EsCode) === -1) {
            this.Subjects.push(element.EsCode);
            this.SubjectName.push(element.EsName);
            this.Sub.push(element.EsOpCode)
            this.AllSub.push(element)
            if (element.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element.EsOpCode);
              }
            }
          }
          if (element.EsOpCode == " " && element.EsType == 'S') {
            const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
            if (!isDuplicate) {
              this.selectedCheckboxes.push(element);
            }
          }
          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsParent) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }
          })
        }
        else if (element.EsType == 'G') {
          this.OptSub = true;
          if (element.EsOpCode !== ' ') {
            const DupOpt = this.selectedOptions.some((item: any) => item === element.EsOpCode);
            if (!DupOpt) {
              this.selectedOptions.push(element.EsOpCode);
            }
          }
          const isDuplicate = this.GroupData.some((item: any) => item.EsId === element.EsId);
          if (!isDuplicate) {
            this.GroupData.push(element);
          }
          element.children.forEach(element1 => {
            if (element1.EsOpCode !== ' ') {
              const DupOpt = this.selectedOptions.some((item: any) => item === element1.EsOpCode);
              if (!DupOpt) {
                this.selectedOptions.push(element1.EsOpCode);
              }
            }

            if (element1.EsOpCode == " ") {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element1);
              }
            }

            this.newSelectedValues.forEach(element2 => {
              if (element2.Code == element1.EsCode && element2.Id == element1.EsParent) {
                const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element1.EsId);
                if (!isDuplicate) {
                  this.selectedCheckboxes.push(element1);
                }

              }

            })
          });

          this.newSelectedValues.forEach(element2 => {
            if (element2.Code == element.EsCode && element2.Id == element.EsId) {
              const isDuplicate = this.selectedCheckboxes.some((item: any) => item.EsId === element.EsId);
              if (!isDuplicate) {
                this.selectedCheckboxes.push(element);
              }

            }

          })
          for (const value of this.newSelectedValues) {
            element.children.forEach(element2 => {
              if (element2.EsOpCode !== ' ') {
                const DupOpt = this.selectedOptions.some((item: any) => item === element2.EsOpCode);
                if (!DupOpt) {
                  this.selectedOptions.push(element2.EsOpCode);
                }
              }
            });
          }

        } 
      });
      await this.getOptionData(EmId, BranchId);
    });


  }


  getOptionData(EmId, BranchId) {
    this.optData = '';
    this.spinner.show();
    const payload = {};
    payload['OpEmId'] = EmId;
    payload['OpStrId'] = BranchId;
    this.umsService.getOption(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status == true) {
        const filteredArray = res.data.filter(item => this.selectedOptions.includes(item.OpCode));
        this.optData = filteredArray;
        this.MinMax = true;
      }
      else {
        this.MinMax = false;
      }
    });
  }


  onSelectionCastCertificat(e) {
    if (e === '1') {
      this.isStuCasteValCertDisable = false
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue('')
    } else {
      this.isStuCasteValCertDisable = true
      this.reservationsDetailsForm.controls['StuCasteValCert'].setValue(2)
    }
  }

  StuNonCrmValDtDisable(e) {
    if (e === '1' || e === 1) {
      this.isStuNonCrmValDtDisable = false
      this.reservationsDetailsForm.controls['StuNonCrmValDt'].setValue(2)
    } else {
      this.reservationsDetailsForm.get('StuNonCrmValDt').patchValue('');
      this.isStuNonCrmValDtDisable = true
    }
  }

  StuOrphanTypeDisable(e) {
    this.isStuOrphanTypeDisable = false
    if (e == 1) {
      this.isStuOrphanTypeDisable = false
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('')
    } else {
      this.isStuOrphanTypeDisable = true
      this.reservationsDetailsForm.controls['StuOrphanType'].setValue('NA')
    }
  }



  StuSpecialAbledTypeDisable(e) {
    this.isStuSpecialAbledTypeDisable = false
    if (e == 1) {

      this.isStuSpecialAbledTypeDisable = false
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('')
    }

    else if (e == 0) {
      this.isStuSpecialAbledTypeDisable = true
      this.reservationsDetailsForm.controls['StuSpecialAbledType'].setValue('NA')

    }
  }



  StuMinorityTypeDisable(e) {
    if (e === 1) {
      this.isStuMinorityTypeDisable = false
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue('')
      this.isStuMinorityType2Disable = false
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue('')
    } else {
      this.isStuMinorityTypeDisable = true
      this.reservationsDetailsForm.controls['StuMinorityType'].setValue(3)
      this.isStuMinorityType2Disable = true
      this.reservationsDetailsForm.controls['StuMinorityType2'].setValue(18)

    }
  }



  fetchAdmInfo() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ADINF';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.AdmInfoCodeList = res.data;
        this.filteredListAdmInfoCode = this.AdmInfoCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  fetchEmpType() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ET';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.EmpTypeCodeList = res.data;
        this.filteredListEmpTypeCode = this.EmpTypeCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }

  getDistrictData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.districtList = res.data;
        this.filteredListdistrictCode = this.districtList.slice();
      }
      else{
        this.spinner.hide();
        this.districtList = []
      }
    
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    });
  }

  getCollegeData(dsCode) {
    this.spinner.show();
    const payload = {};
    payload['DsCode'] = dsCode
    this.umsService.DistrictWiseCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegedataList = res.data;
      this.filteredListCollege = this.collegedataList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegedataList = [];
      this.spinner.hide();
    })
  }

  fetchMedium() {
    this.spinner.show()
    const payload = {};
    payload['CdType'] = 'ME';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.MediumCodeList = res.data;
        this.filteredListMediumCode = this.MediumCodeList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }


  fetchFeeResponces(SnNo,StuId) {
    this.spinner.show()
    const payload = {};
    payload['StuId'] = StuId;
    payload['SnNo'] = SnNo;
    this.umsService.getFeeResponse(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
       } else {
        this.spinner.hide();
        this.showchattt = false
        this.message = "Fees Not Paid"
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
  }
}
